<template>
  <transition name="fade">
    <div
      v-if="visible && (matterinfodata.id || detailType === 'editorPictureDetail')"
      class="modal detail_box"
    >
      <div class="detail">
        <div class="titles msp_icon_close">
          <span class="title_name">素材详情</span>
          <span
            class="iconfont el-icon-close"
            @click.stop="closeBox()"
          />
        </div>
        <div class="detail_el_scroll">
          <div class="detail_img">

            <div
              class="operate_img"
              v-if="detailType !== 'editorPictureDetail' && articleData && articleData.ctrl && articleData.ctrl.role && articleData.ctrl.role.edit"
            >
              <span
                class="first_line"
                @click.stop='changeMatterBaseInfo()'
              >
                修改信息
              </span>
              <span
                class="first_line"
                @click.stop='downLoadMatter()'
              >下载</span>
            </div>

            <div class="detail_img_info">
              <el-image
                v-if="(detailType === 'imgDetail' || detailType === 'editorPictureDetail') && matterinfodata && matterinfodata.url"
                :src="matterinfodata.url"
                :alt="alt"
                :fit="fit"
                style="width:100%; height: 100%"
                class="el-image-class"
              >
                <div
                  slot="error"
                  class="image-slot"
                >
                  <i class="el-icon-picture-outline" />
                </div>
              </el-image>

              <video
                v-if="detailType === 'videoDetail'"
                width="100%"
                controls="controls"
                :src="matterinfodata.url"
                :poster="matterinfodata.cover_img"
              >
                <source type="video/ogg">
                <source type="video/mp4">
              </video>
              <div
                v-if="false && (detailType === 'videoDetail')"
                class="video_define"
              >
                <div
                  class="each_define_button"
                  v-for="(item,index) in definelist"
                  :key="index"
                >
                  <el-button
                    type="primary"
                    round
                  >{{ item }}</el-button>
                </div>
              </div>

              <div
                v-if="detailType === 'audioDetail'"
                class="audio_player"
              >
                <el-image
                  :src="audioUrl"
                  :alt="alt"
                  :fit="fit"
                  style="width:100%; height: 100%;"
                  class="el-image-class"
                >
                  <div
                    slot="error"
                    class="image-slot"
                  >
                    <i class="el-icon-picture-outline" />
                  </div>
                </el-image>
                <div class="audio_player_content">
                  <audio
                    id="audio"
                    ref="audio"
                    controls="controls"
                    preload
                    :src="matterinfodata.url"
                  >
                    <source type="audio/ogg">
                    <source type="audio/mpeg">
                  </audio>
                </div>
              </div>
            </div>
            <div
              class="editor_logs"
              v-if="detailType !== 'editorPictureDetail'"
            >
              <div class="editor_logs_title">
                <el-tabs
                  v-model="activeLogName"
                  :stretch='stretch'
                  style="width:100%;"
                >
                  <el-tab-pane
                    :label="item.name"
                    :name="item.path"
                    :key="item.path"
                    v-for="(item,index) in tabData"
                  >{{item.name}}</el-tab-pane>
                </el-tabs>
              </div>
              <div class="editor_logs_content">
                <matterinfo
                  v-if="activeLogName === 'matterInfo'"
                  :matterinfodata="matterinfodata"
                  :matterinfotype="detailType"
                ></matterinfo>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import matterinfo from '../logs/matterinfo'
import { download } from '../../../helpers/exportFile'
import * as api from '../../../api'
export default {
  components: {
    matterinfo
  },
  data () {
    return {
      visible: false,
      fit: 'contain',
      alt: '图片加载失败',
      audioUrl: '../../../static/img/audio_bg.png',
      activeLogName: 'matterInfo',
      stretch: true,
      tabData: [{ name: '素材信息', path: 'matterInfo' }],
      matterinfodata: {},
      detailType: 'imgDetail',
      definelist: ['流场', '标清', '高清', '超清'],
      articleData: ''
    }
  },
  computed: {

  },

  mounted () {
    this.$root.eventHub.$on('getMatterDetail', (data, type, article) => {
      this.visible = true
      this.detailType = type
      this.matterinfodata = data
      this.activeLogName = 'matterInfo'
      if (article) {
        this.articleData = article
      }
    })
  },
  destroyed () {
    this.$root.eventHub.$off('getMatterDetail')
  },
  methods: {
    closeBox () {
      this.visible = false
    },
    changeMatterBaseInfo () {
      this.$root.eventHub.$emit('singleModifyInfoModel', this.matterinfodata, this.matterinfodata.type)
    },
    downLoadMatter () {
      var url = _IMGFILEURL_ + 'downloader/url'
      var option = {
        ...this.$store.getters.baseOption,
        'params': {
          'id': this.matterinfodata.id
        }
      }
      if (this.matterinfodata.type === 'picture' || this.matterinfodata.type === 'file') {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            download(res.data)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.downloadVideo(this.matterinfodata.url, this.matterinfodata.title)
      }
    },
    downloadVideo (url, filename) {
      var link = document.createElement('a')
      var body = document.querySelector('body')
      link.href = url
      link.download = filename
      link.target = '_blank'
      // fix Firefox
      link.style.display = 'none'
      body.appendChild(link)
      link.click()
      body.removeChild(link)
      window.URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.detail_box
  .detail
    position relative
    width 86%
    height 80%
    border-radius 6px
    background #E9EAEC
    box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.35)

    .titles
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      background #fff
      box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)

      .title_name
        float left
        color #303133
        font-size 16px
        line-height 48px

      .iconfont
        float right
        color #606266
        font-size 22px
        line-height 48px
        cursor pointer

    .detail_el_scroll
      overflow auto
      box-sizing border-box
      height calc(100% - 48px)

      .detail_img
        display flex
        box-sizing border-box
        margin-top 20px
        padding-right 20px
        padding-left 60px
        height 90%

        .operate_img
          display flex
          flex-direction column
          justify-content center
          align-items flex-end
          box-sizing border-box
          padding-top 20px
          width 65px

          span.first_line
            position relative
            display block
            margin-top 6px
            width 65px
            height 36px
            border-radius 5px 0 0 5px
            background white
            box-shadow #d2d3d5 0 0 5px 2px
            color #606266
            text-align center
            font-size 14px
            line-height 36px
            cursor pointer

            &:hover
              width 88px
              text-align center

        .detail_img_info
          position relative
          display flex
          flex 1
          justify-content center
          align-items center
          box-sizing border-box
          margin-left 2px
          padding 20px
          height 100%
          border-radius 6px
          background #fff

          .video_define
            position absolute
            bottom 0
            left 0
            display flex
            align-items center
            width 100%
            height 60px

            .each_define_button
              margin-left 20px

              button
                padding 0
                width 88px
                height 38px
                border 0
                background #fff
                box-shadow 0 3px 7px 0px rgba(0, 0, 0, 0.15)
                color #606266

                &:hover
                  background #688EFF
                  color #fff

          video
            margin-top 0px
            height 90%

          .audio_player
            position relative
            display flex
            justify-content center
            align-items center
            width 100%
            height 100%
            background linear-gradient(360deg, rgba(238, 238, 238, 1) 0%, rgba(212, 212, 212, 1) 100%)

            .audio_player_content
              position absolute
              bottom 0px
              left 0px
              display flex
              justify-content center
              align-items center
              box-sizing border-box
              padding-right 20px
              padding-left 20px
              width 100%
              height 100px

              audio
                width 100%

        .editor_logs
          margin-left 64px
          width 440px
          height 100%
          border-radius 6px
          background #fff

        .editor_logs_title
          height 50px

        .editor_logs_content
          height calc(100% - 50px)

      .detail_img_sort
        position relative
        display flex
        box-sizing border-box
        margin-top 20px
        margin-bottom 20px
        padding-right 62px
        padding-left 72px
        height 188px

        .sort_button
          position absolute
          top 0px
          width 42px
          height 100%
          border 1px solid #F0F1F3
          border-radius 6px
          background #fff
          text-align center
          line-height 188px
          cursor pointer
          transition all 0.3s ease-in-out

          &:hover
            background #688EFF

            span
              color #fff

          span
            color #606266
            font-size 26px

        .detail_img_sortlist
          display flex
          flex 1
          box-sizing border-box
          margin-right 10px
          margin-left 10px
          height 188px

          .detail_each_sortimg
            position relative
            flex 1
            box-sizing border-box
            margin-right 10px
            height 100%
            background #fff
            cursor pointer
            transition all 0.3s ease-in-out

            &:hover
              box-shadow 0px 1px 10px 2px rgba(131, 128, 128, 0.2)
              transform scale(1.03)

            .opacity_title
              position absolute
              bottom 0
              left 0
              z-index 10
              box-sizing border-box
              padding-left 10px
              width 100%
              height 38px
              background rgba(0, 0, 0, 0.7)

              span
                display inline-block
                overflow hidden
                width 98%
                color #fff
                text-overflow ellipsis
                white-space nowrap
                font-size 16px
                line-height 38px

            .video_player_opacity
              position absolute
              top 0
              left 0
              display flex
              justify-content center
              align-items center
              width 100%
              height 100%
</style>
